import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import baseURL from '../component/baseURL';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import { ReactNotifications } from 'react-notifications-component';
import showNotification from '../component/Notification';
import stringsoflanguages from '../component/stringsoflanguages';

export default function PortfolioDetails() {

    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const fromMyListings = location.state?.from === 'my-listings';
    const fromMyPortfolio = location.state?.from === 'my-portfolio';
    const fromGlobalPortfolio = location.state?.from === 'global-portfolio';
    const fromFeedActive = location.state?.from === 'feed-active';
    const fromNewAvailable = location.state?.from === 'new-available';

    function handlePortfolioDetailsBack() {
        const returnTo = location.state?.returnTo;
        if (returnTo?.path) {
            const backState = returnTo.state ?? {};
            const isMainMyListings =
                returnTo.path === '/home/my-listings' && backState.fromSidebar === true;
            const isMainMyPortfolio =
                returnTo.path === '/home/my-portfolio' && backState.fromSidebar === true;
            const isMainGlobalPortfolio =
                returnTo.path === '/home/global-portfolio' && backState.fromGlobalPortfolioRoot === true;
            navigate(returnTo.path, {
                replace: true,
                state: isMainMyListings || isMainMyPortfolio
                    ? { fromSidebar: true, scrollPosition: backState.scrollPosition }
                    : isMainGlobalPortfolio
                        ? { fromGlobalPortfolioRoot: true, scrollPosition: backState.scrollPosition }
                        : backState,
            });
            return;
        }
        if (fromMyListings) {
            navigate('/home/my-listings', { replace: true, state: { fromSidebar: true } });
            return;
        }
        if (fromMyPortfolio) {
            navigate('/home/my-portfolio', { replace: true, state: { fromSidebar: true } });
            return;
        }
        if (fromGlobalPortfolio) {
            navigate('/home/global-portfolio', { replace: true, state: { fromGlobalPortfolioRoot: true } });
            return;
        }
        if (fromFeedActive) {
            navigate('/feed/my-feed-active', { replace: true });
            return;
        }
        navigate(-1);
    }
    const isMember = location.state?.is_member === '1' || location.state?.is_member === 1;
    const showFavoriteBtn = true;
    const [userID, setUserID] = useState('');
    const [agentKey, setAgentkey] = useState('');
    const [agentID, setAgentID] = useState('');
    const [listingID, setListingID] = useState('');
    const [otherResult, setOtherResult] = useState('');
    const [infoCardResult, setInfoCardResult] = useState([]);
    const [listingImage, setListingImage] = useState('');
    const [portfolioImages, setPortfolioImages] = useState([]);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [propertyType, setPropertyType] = useState('');
    const [publicRemarks, setPublicRemarks] = useState('');
    const [province, setProvince] = useState('');
    const [iframeFlag, setIframeFlag] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const [gearMenuOpen, setGearMenuOpen] = useState(false);
    const [gearSpinning, setGearSpinning] = useState(false);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [folderModalOpen, setFolderModalOpen] = useState(false);
    const [view360ModalOpen, setView360ModalOpen] = useState(false);
    const [isEditing360Link, setIsEditing360Link] = useState(false);
    const [isAdd360Mode, setIsAdd360Mode] = useState(false);
    const [view360Link, setView360Link] = useState('');
    const [view360Input, setView360Input] = useState('');
    const [isFetching360Link, setIsFetching360Link] = useState(false);
    const gearMenuRef = useRef(null);
    const isOwnAgent = String(agentID ?? '') !== '' && String(agentID) === String(userID ?? '');
    const showOwnerListingActions = fromMyListings || isOwnAgent;
    const [resultAll, setResultAll] = useState({});

    const openFolderModal = () => {
        setGearMenuOpen(false);
        setFolderModalOpen(true);
    };

    const closeFolderModal = () => setFolderModalOpen(false);

    const normalizeUrl = (url) => {
        const value = String(url ?? '').trim();
        if (!value) return '';
        if (/^https?:\/\//i.test(value)) return value;
        return `https://${value}`;
    };


    const handleFolderPublic = () => {
        closeFolderModal();
        showNotification('Info', 'Public', 'info');
    };

    const handleFolderPrivate = () => {
        closeFolderModal();
        showNotification('Info', 'Private', 'info');
    };

    const handleFolderEdit = () => {
        closeFolderModal();
        showNotification('Info', 'Edit', 'info');
    };

    const openView360Modal = async () => {
        setGearMenuOpen(false);
        const existing = await fetch360Link();
        setView360Link(existing);
        setView360Input(existing);
        setIsEditing360Link(false);
        setIsAdd360Mode(false);
        setView360ModalOpen(true);
    };

    const closeView360Modal = () => {
        setView360ModalOpen(false);
        setIsEditing360Link(false);
        setIsAdd360Mode(false);
    };

    const handleOpen360Link = async () => {
        let link = normalizeUrl(view360Link || view360Input);
        if (!link) {
            link = await fetch360Link();
        }
        if (!link) {
            showNotification('Info', 'No link available', 'info');
            return;
        }
        window.open(link, '_blank', 'noopener,noreferrer');
    };

    const isUrlValid = (userInput) => {
        const res = String(userInput ?? '').match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g);
        return res !== null;
    };

    const submit360Link = async () => {
        const resolvedUserId = userID || localStorage.getItem('userID') || localStorage.getItem('user_id') || '';
        const resolvedListingId = listingID || location.state?.listingID || '';
        const rawLink = String(view360Input ?? '').trim();

        if (!resolvedListingId) {
            showNotification('Error', 'Listing ID missing', 'danger');
            return false;
        }

        // Add submit: Add mode must hit add_edit_360link
        if (isAdd360Mode) {
            if (!isUrlValid(rawLink)) {
                showNotification('Error', 'Please enter a valid link', 'danger');
                return false;
            }
            const formdata = new FormData();
            formdata.append('key', '81dc9bdb52d04dc20036dbd8313ed055');
            formdata.append('link_360', normalizeUrl(rawLink));
            formdata.append('listing_id', resolvedListingId);
            try {
                const response = await fetch(baseURL.URL + '/portfolio/add_edit_360link', {
                    method: 'POST',
                    body: formdata
                });
                const responseJson = await response.json();
                const code = Number(responseJson?.server?.result_code ?? responseJson?.server?.code);
                if (code !== 200) {
                    showNotification('Error', responseJson?.server?.message || 'Failed to save 360 link', 'danger');
                    return false;
                }
            } catch (error) {
                console.error(error);
                showNotification('Error', 'Failed to save 360 link', 'danger');
                return false;
            }
        } else {
            // Edit submit (else part): call add_edit_listing_link
            const formdata = new FormData();
            formdata.append('user_id', resolvedUserId);
            formdata.append('key', '81dc9bdb52d04dc20036dbd8313ed055');
            formdata.append('link', rawLink);
            formdata.append('listing_id', resolvedListingId);
            try {
                const response = await fetch(baseURL.URL + '/portfolio/add_edit_listing_link', {
                    method: 'POST',
                    body: formdata
                });
                const responseJson = await response.json();
                const code = Number(responseJson?.server?.result_code ?? responseJson?.server?.code);
                if (code !== 200) {
                    showNotification('Error', responseJson?.server?.message || 'Failed to update listing link', 'danger');
                    return false;
                }
            } catch (error) {
                console.error(error);
                showNotification('Error', 'Failed to update listing link', 'danger');
                return false;
            }
        }

        // Fetch only for showing latest data
        const fetched = await fetch360Link(resolvedUserId, resolvedListingId);
        setView360Link(fetched);
        setView360Input(fetched);
        setOtherResult((prev) => ({ ...(prev || {}), view_360_link: fetched }));
        return true;
    };

    const handleSave360Link = async () => {
        const ok = await submit360Link();
        if (ok) {
            setIsEditing360Link(false);
            showNotification('Success', '360 link updated', 'success');
        }
    };

    const openDeleteConfirm = () => {
        setGearMenuOpen(false);
        setDeleteConfirmOpen(true);
    };

    const closeDeleteConfirm = () => setDeleteConfirmOpen(false);

    const confirmDeleteListing = () => {
        setDeleteConfirmOpen(false);
        removeListing();
    };

    const goToEditListing = () => {
        setGearMenuOpen(false);
        if (!listingID) return;
        navigate('/home/edit-listing', {
            state: {
                listingID,
                returnTo: {
                    path: '/portfolio-details',
                    state: { ...location.state, listingID },
                },
            },
        });
    };

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 767);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const handleGearClickOutside = (e) => {
            if (gearMenuRef.current && !gearMenuRef.current.contains(e.target)) {
                setGearMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleGearClickOutside);
        return () => document.removeEventListener('mousedown', handleGearClickOutside);
    }, []);

    useEffect(() => {
        console.log('portfolioImages state updated:', portfolioImages);
    }, [portfolioImages]);

    useEffect(() => {
        if (!userID || !listingID) return;
        fetch360Link(userID, listingID);
    }, [listingID, userID]);

    useEffect(() => {

        const userid = localStorage.getItem('userID') || localStorage.getItem('user_id') || '';
        setUserID(userid);
        const agentKey = localStorage.getItem('agentKey');
        setAgentkey(agentKey);
        const agentid = location.state?.agentID ?? localStorage.getItem('agentID') ?? '';
        setAgentID(agentid);
        const listingid = location.state?.listingID ?? '';
        setListingID(listingid);

        if (listingid && userid) fetchDetailsAPI(userid, listingid);
        else setIsLoading(false);

        if (userid && listingid) {
            fetch360Link(userid, listingid);
        }

        // Add class to body when component mounts
        document.body.classList.add('details-page');

        // Initialize Fancybox
        Fancybox.bind('[data-fancybox="gallery"]', {
            Toolbar: {
                display: {
                    left: ["infobar"],
                    middle: [],
                    right: ["slideshow", "download", "thumbs", "close"],
                },
            },
            Thumbs: {
                autoStart: false,
            },
            Carousel: {
                infinite: true,
            },
        });

        // Remove class when component unmounts
        return () => {
            document.body.classList.remove('details-page');
            Fancybox.unbind('[data-fancybox="gallery"]');
            Fancybox.close();
        };

    }, []);


    const formatPrice = (price) => {
        if (price === null || price === undefined) {
            return '';
        }

        const priceString = price.toString();
        const match = priceString.match(/^(\D*)(\d+)(.*)$/);

        if (!match) {
            return priceString;
        }

        const [, prefix, digits, suffix] = match;
        const formattedDigits = digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return `${prefix}${formattedDigits}${suffix}`;
    };

    const handleThumbnailClick = (index) => {
        setCurrentImageIndex(index);
        setListingImage(portfolioImages[index].imagename);
    };

    const handlePrevClick = () => {
        if (portfolioImages.length > 0) {
            const newIndex = currentImageIndex === 0 ? portfolioImages.length - 1 : currentImageIndex - 1;
            setCurrentImageIndex(newIndex);
            setListingImage(portfolioImages[newIndex].imagename);
        }
    };

    const handleNextClick = () => {
        if (portfolioImages.length > 0) {
            const newIndex = currentImageIndex === portfolioImages.length - 1 ? 0 : currentImageIndex + 1;
            setCurrentImageIndex(newIndex);
            setListingImage(portfolioImages[newIndex].imagename);
        }
    };

    const handleExpandClick = () => {
        if (!Array.isArray(portfolioImages) || portfolioImages.length === 0) return;

        // Support multiple API image key shapes.
        const images = portfolioImages
            .map((img) => img?.imagename ?? img?.image_name ?? img?.image ?? img?.url ?? '')
            .filter((src) => typeof src === 'string' && src.trim() !== '')
            .map((src) => ({ src }));

        if (images.length === 0) {
            showNotification('Error', 'No gallery images found', 'danger');
            return;
        }

        const safeStartIndex = Math.min(Math.max(currentImageIndex, 0), images.length - 1);

        Fancybox.show(images, {
            startIndex: safeStartIndex,
            Toolbar: {
                display: {
                    left: ["infobar"],
                    middle: [],
                    right: ["slideshow", "download", "thumbs", "close"],
                },
            },
            Thumbs: {
                autoStart: false,
            },
            Carousel: {
                infinite: true,
            },
        });
    };



    function fetchDetailsAPI(userid, listingid) {

        var alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        console.log(alphabet.replace(/H.*S/, ''))

        let formdata = new FormData();
        formdata.append("user_id", userid)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        formdata.append("listing_id", String(listingid))
        console.log(formdata)

        fetch(baseURL.URL + '/portfolio/portfolio_details', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                if (!responseJson || responseJson.server?.code !== 200) {
                    showNotification('Error', responseJson?.server?.message || 'Failed to load details', 'danger');
                    setIsLoading(false);
                    return;
                }
                const filter = responseJson.response?.filter ?? responseJson.data?.response?.filter
                const present = filter?.present ?? responseJson.data?.response?.filter?.present
                const resultAll = responseJson.response ?? responseJson.data?.response
                if (!present) {
                    showNotification('Error', 'No listing data found', 'danger');
                    setIsLoading(false);
                    return;
                }

                const agentResult = present.agent_details || {}
                const resolvedAgentId = agentResult.agent_id ?? agentResult.user_id ?? '';
                if (resolvedAgentId !== '') {
                    setAgentID(String(resolvedAgentId));
                }
                // info_card_shown: try present, then nested, then filter/response (support different API shapes)
                const rawInfoCard = present.info_card_shown
                    ?? present.listing_details?.info_card_shown
                    ?? present.details?.info_card_shown
                    ?? filter?.info_card_shown
                    ?? responseJson.response?.info_card_shown
                    ?? responseJson.data?.response?.info_card_shown
                let infoCardArr = []
                if (Array.isArray(rawInfoCard)) {
                    infoCardArr = rawInfoCard
                } else if (rawInfoCard && typeof rawInfoCard === 'object' && !Array.isArray(rawInfoCard)) {
                    infoCardArr = Object.keys(rawInfoCard).map(k => rawInfoCard[k]).filter(Boolean)
                }

                function getField(arr, label) {
                    if (!arr || !arr.length) return null
                    const f = arr.find(x => (x.field_name_label === label || x.field_name === label))
                    if (!f) return null
                    const v = f.field_value !== undefined && f.field_value !== null && f.field_value !== ''
                        ? f.field_value
                        : (Array.isArray(f.data) && f.data[0] !== undefined && f.data[0] !== null ? f.data[0] : null)
                    return (v !== undefined && v !== null && String(v).trim() !== '') ? v : null
                }
                function getFieldByLabels(arr, ...labels) {
                    for (const label of labels) {
                        const v = getField(arr, label)
                        if (v != null) return v
                    }
                    return null
                }

                const myData = []
                for (let i = 0; i < infoCardArr.length; i++) {
                    if (infoCardArr[i].field_name_label !== 'BedroomsTotal' && infoCardArr[i].field_name_label !== 'ListPrice'
                        && infoCardArr[i].field_name_label !== 'StreetNumber' && infoCardArr[i].field_name_label !== 'StreetName'
                        && infoCardArr[i].field_name_label !== 'StandardStatus' && infoCardArr[i].field_name_label !== 'City'
                        && infoCardArr[i].field_name_label !== 'BathroomsTotalInteger' && infoCardArr[i].field_name_label !== 'PostalCode'
                        && infoCardArr[i].field_name_label !== 'GarageSpaces' && infoCardArr[i].field_name_label !== 'ParkingTotal' && infoCardArr[i].field_name_label !== 'LivingArea' && infoCardArr[i].field_name_label !== 'LivingAreaUnits' && infoCardArr[i].field_name_label !== 'LivingAreaUnit'
                        && infoCardArr[i].field_name_label !== 'PropertyType' && infoCardArr[i].field_name_label !== 'ListingId' && infoCardArr[i].field_name_label !== 'StateOrProvince' && infoCardArr[i].field_name_label !== 'SurfaceArea' && infoCardArr[i].field_name_label !== 'SurfaceAreaUnit' && infoCardArr[i].field_name_label !== 'BuildArea' && infoCardArr[i].field_name_label !== 'f2/m2'
                    ) {
                        myData.push(infoCardArr[i])
                    }

                    if (infoCardArr[i].field_name_label === 'ListingId') {
                        setPropertyType(infoCardArr[i].field_value ?? infoCardArr[i].data?.[0] ?? '')
                    } else if (infoCardArr[i].field_name_label === 'PropertyType') {
                        setPropertyType(infoCardArr[i].field_value ?? infoCardArr[i].data?.[0] ?? '')
                    } else if (infoCardArr[i].field_name_label === 'StateOrProvince') {
                        setProvince(infoCardArr[i].field_value ?? infoCardArr[i].data?.[0] ?? '')
                    } else if (infoCardArr[i].field_name_label === 'PublicRemarks') {
                        const val = infoCardArr[i].field_value ?? infoCardArr[i].data?.[0]
                        if (typeof val === 'string' && val.includes('<iframe')) setIframeFlag(true)
                        setPublicRemarks(val ?? '')
                    }
                }

                const listPrice = getField(infoCardArr, 'ListPrice') ?? present.list_price
                const cityName = getField(infoCardArr, 'City') ?? present.city_name
                const streetNumber = getField(infoCardArr, 'StreetNumber') ?? present.StreetNumber
                const streetName = getField(infoCardArr, 'StreetName') ?? present.StreetName
                const stateOrProvince = getField(infoCardArr, 'StateOrProvince') ?? present.StateOrProvince
                const postalCode = getField(infoCardArr, 'PostalCode') ?? present.PostalCode
                const country = getField(infoCardArr, 'Country') ?? present.country_name
                const addressParts = [streetNumber, streetName, cityName, stateOrProvince, postalCode, country].filter(Boolean)
                const address = addressParts.join(', ').trim() || null
                const listingIdLabel = getField(infoCardArr, 'ListingId')

                setResultAll(resultAll)
                setInfoCardResult(infoCardArr)
                setOtherResult({
                    ...present,
                    list_price: listPrice,
                    city_name: cityName ?? listingIdLabel,
                    address: address,
                    PostalCode: postalCode ?? present.PostalCode,
                    BedroomsTotal: getField(infoCardArr, 'BedroomsTotal') ?? present.BedroomsTotal,
                    BathroomsTotalInteger: getField(infoCardArr, 'BathroomsTotalInteger') ?? present.BathroomsTotalInteger,
                    LivingArea: present.LivingArea ?? getField(infoCardArr, 'LivingArea') ?? getField(infoCardArr, 'BuildArea') ?? present.LotSizeArea,
                    LivingAreaUnits: present.LivingAreaUnits ?? getFieldByLabels(infoCardArr, 'LivingAreaUnits', 'f2/m2', 'f2\\/m2') ?? present.LotSizeUnits,
                    GarageSpaces: getField(infoCardArr, 'GarageSpaces') ?? present.GarageSpaces,
                    ParkingTotal: getField(infoCardArr, 'ParkingTotal') ?? present.ParkingTotal,
                    StreetNumber: streetNumber,
                    StreetName: streetName,
                    StateOrProvince: stateOrProvince,
                    Country: country,
                    agent_image: agentResult.agent_image,
                    company_image: agentResult.company_image,
                    company_image_thumb: agentResult.company_image_thumb,
                    agent_name: agentResult.agent_name,
                    member_fname: agentResult.member_fname,
                    member_lname: agentResult.member_lname,
                })

                if (typeof isShareCheck === 'function') isShareCheck(agentResult.agent_id)

                const portfolioImg = present.portfolio_img
                const firstImg = Array.isArray(portfolioImg) && portfolioImg.length > 0 ? portfolioImg[0] : null
                if (!firstImg || !firstImg.imagename) {
                    setListingImage('https://www.yesmls.com/yes100/assets/images/no-listing-image.png')
                    setPortfolioImages([])
                } else {
                    setListingImage(firstImg.imagename)
                    setPortfolioImages(portfolioImg)
                    setTimeout(() => { handleExpandClick() }, 10)
                }
                setIsLoading(false);
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Network error loading details', 'danger');
                setIsLoading(false);
            });
    }



    function askInfoApi() {
        // this.setState({ isLoading: true })
        // const { navigate } = this.props.navigation;
        let formdata = new FormData();
        formdata.append("user_id", userID)
        formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
        formdata.append("listing_id", listingID)
        formdata.append("agent_key", agentKey)
        console.log(formdata);
        fetch(baseURL.URL + '/consumer_portfolio/ask_info', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                console.log('ASK INFO API ******************')
                console.log(responseJson);
                if (responseJson.server.result_code == 200) {
                    //   this.setState({ isLoading: false })
                    //   Toast.showWithGravity(responseJson.server.message, Toast.SHORT, Toast.BOTTOM)
                    showNotification('Success', responseJson.server.message, 'success');
                    setTimeout(() => { fetchDetailsAPI(userID, listingID) }, 50)
                } else {
                    //   this.setState({ isLoading: false })
                    //   Toast.showWithGravity(responseJson.server.message, Toast.SHORT, Toast.BOTTOM)
                    showNotification('Error', responseJson.server.message, 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }


    function makeFav(listingId) {
        if (!listingId || !userID) {
            console.warn('Missing data to mark favorite', { listingId, userid });
            return;
        }

        // Get current favorite status and toggle it
        const currentFavoriteStatus = otherResult.is_favorite;
        const newFavoriteStatus = currentFavoriteStatus === '1' || currentFavoriteStatus === 1 ? '0' : '1';

        // Optimistically update the state
        setOtherResult({
            ...otherResult,
            is_favorite: newFavoriteStatus
        });

        // Show notification based on favorite status
        if (newFavoriteStatus === '1') {
            showNotification('Success', 'Added to favorites', 'success');
        } else {
            showNotification('Success', 'Removed from favorites', 'success');
        }

        const formdata = new FormData();
        formdata.append("user_id", userID);
        formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055');
        formdata.append("listing_id", listingId);
        // formdata.append("agent_id", agentID);
        formdata.append("is_favorite", newFavoriteStatus);

        fetch(baseURL.URL + '/portfolio/listing_favorites', {
            method: 'POST',
            body: formdata
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server.code !== 200) {
                    // Revert the optimistic update on error
                    setOtherResult({
                        ...otherResult,
                        is_favorite: currentFavoriteStatus
                    });
                    showNotification('Error', responseJson.server.message || 'Unable to update favorite', 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                // Revert the optimistic update on error
                setOtherResult({
                    ...otherResult,
                    is_favorite: currentFavoriteStatus
                });
                showNotification('Error', 'Something went wrong while updating favorite', 'danger');
            });
    }


    function removeListing() {
        console.log('User ID : ' + userID)
        let formdata = new FormData();
        formdata.append("user_id", userID)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        formdata.append("listing_id", listingID)
        fetch(baseURL.URL + '/portfolio/portfolio_remove', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {

                const code = responseJson.server?.result_code ?? responseJson.server?.code;
                if (Number(code) === 200) {
                    setTimeout(() => {
                        showNotification('Success', 'Listing removed successfully', 'success');
                        navigate('/home/my-listings');
                    }, 1000);
                } else {
                    showNotification('Error', responseJson.server?.message || 'Could not remove listing', 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Something went wrong while removing listing', 'danger');
            });
    }

    async function fetch360Link(useridArg, listingidArg) {
        const resolvedUserId = useridArg || userID || localStorage.getItem('userID') || localStorage.getItem('user_id') || '';
        const resolvedListingId = listingidArg || listingID || location.state?.listingID || '';
        if (!resolvedUserId || !resolvedListingId) return '';
        setIsFetching360Link(true);
        let formdata = new FormData();
        formdata.append("user_id", resolvedUserId);
        formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
        formdata.append("listing_id", resolvedListingId)
        try {
            const response = await fetch(baseURL.URL + '/portfolio/fetch_360_link', {
                method: 'POST',
                body: formdata
            });
            const responseJson = await response.json();
            const code = Number(responseJson?.server?.result_code ?? responseJson?.server?.code);
            if (code !== 200) {
                setView360Link('');
                return '';
            }
            const result = responseJson?.response?.result ?? responseJson?.response ?? {};
            const fetched = normalizeUrl(
                result?.['360View'] ??
                result?.link_360 ??
                result?.view_360_link ??
                result?.view360_link ??
                ''
            );
            setView360Link(fetched);
            return fetched;
        } catch (error) {
            console.error(error);
            setView360Link('');
            return '';
        } finally {
            setIsFetching360Link(false);
        }
    }


    return (
        <>
            <ReactNotifications />
            <main className="main-content">
                <div className="container">
                    {isLoading ? (
                        <div className='loading-filters' style={{
                            textAlign: 'center',
                            padding: '60px 20px',
                            color: '#666',
                            height: '100vh',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                width: '50px',
                                height: '50px',
                                border: '4px solid #f3f3f3',
                                borderTop: '4px solid #1C4CAF',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite',
                                margin: '0 auto 20px'
                            }}></div>
                            <h3 style={{ fontSize: '24px', marginBottom: '10px', color: '#333' }}>{stringsoflanguages.loading}</h3>
                            <p style={{ fontSize: '16px', color: '#999' }}>{stringsoflanguages.pleaseWaitWhileWeFetchThePropertyDetails}</p>
                        </div>
                    ) : (
                        <>
                            <div className="back-btn" aria-label="Back" onClick={handlePortfolioDetailsBack}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M12.5 15L7.5 10L12.5 5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <section className="details-layout">
                                <div className="layout-left">
                                    <section className="details-gallery details-gallery-full">
                                        <div className="gallery-full-wrap">
                                            {showFavoriteBtn && (
                                                <button
                                                    className={`favorite-btn ${otherResult && (otherResult.is_favorite === '1' || otherResult.is_favorite === 1) ? 'active' : ''}`}
                                                    aria-label="Favorite"
                                                    onClick={() => makeFav(listingID)}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                                                        <path d="M0 5.85219C0 10.7151 4.01943 13.3065 6.96173 15.626C8 16.4445 9 17.2151 10 17.2151C11 17.2151 12 16.4445 13.0383 15.626C15.9806 13.3065 20 10.7151 20 5.85219C20 0.98925 14.4998 -2.45945 10 2.21572C5.50016 -2.45945 0 0.98925 0 5.85219Z" fill="white" />
                                                    </svg>
                                                </button>
                                            )}
                                            <div className="status">
                                                {otherResult?.StandardStatus === 'Active' && (
                                                    <>
                                                        <span className="status-dot active"></span>
                                                        <span>{otherResult?.StandardStatus}</span>
                                                    </>
                                                )}
                                                {otherResult?.StandardStatus === 'Coming Soon' && (
                                                    <>
                                                        <span className="status-dot coming-soon"></span>
                                                        <span>{otherResult?.StandardStatus}</span>
                                                    </>
                                                )}
                                                {otherResult?.StandardStatus === 'Sold' && (
                                                    <>
                                                        <span className="status-dot sold"></span>
                                                        <span>{otherResult?.StandardStatus}</span>
                                                    </>
                                                )}
                                                {otherResult?.StandardStatus === 'Cancelled' && (
                                                    <>
                                                        <span className="status-dot cancelled"></span>
                                                        <span>{otherResult?.StandardStatus}</span>
                                                    </>
                                                )}
                                                {otherResult?.StandardStatus === 'Under Offer' && (
                                                    <>
                                                        <span className="status-dot under-offer"></span>
                                                        <span>{otherResult?.StandardStatus}</span>
                                                    </>
                                                )}
                                                {(!otherResult?.StandardStatus || !['Active', 'Coming Soon', 'Sold', 'Cancelled', 'Under Offer'].includes(otherResult?.StandardStatus)) && (
                                                    <>
                                                        <span className="status-dot"></span>
                                                        <span>{otherResult?.StandardStatus || 'N/A'}</span>
                                                    </>
                                                )}
                                            </div>
                                            <img
                                                className="gallery-main"
                                                src={listingImage || undefined}
                                                alt="Property main"
                                                referrerPolicy="no-referrer"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = 'https://www.yesmls.com/yes100/assets/images/no-listing-image.png';
                                                }}
                                            />
                                            {/* <button className="gallery-expand" aria-label="Expand" onClick={handleExpandClick}><i className="fa-solid fa-up-right-and-down-left-from-center"></i></button> */}
                                            {portfolioImages && portfolioImages.length > 0 && (
                                                <button
                                                    type="button"
                                                    className="gallery-thumb-overlay"
                                                    onClick={(e) => { e.preventDefault(); handleExpandClick(); }}
                                                    aria-label={`View ${portfolioImages.length} images`}
                                                >
                                                    <img
                                                        src={(portfolioImages[currentImageIndex]?.imagename ?? portfolioImages[currentImageIndex]?.image_name ?? portfolioImages[currentImageIndex]?.image ?? portfolioImages[currentImageIndex]?.url) || listingImage}
                                                        alt="Gallery"
                                                        referrerPolicy="no-referrer"
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = 'https://www.yesmls.com/yes100/assets/images/no-listing-image.png';
                                                        }}
                                                    />
                                                    {portfolioImages.length > 1 && (
                                                        <span className="gallery-thumb-count">
                                                            +{portfolioImages.length - 1}
                                                        </span>
                                                    )}
                                                </button>
                                            )}
                                        </div>
                                    </section>
                                    <section className="summary-left">
                                        <div className="summary-card">
                                            <div className="summary-header">
                                                <div className="summary-title-group">
                                                    <h2 className="summary-title">{otherResult?.PostalCode ?? ''} {otherResult?.city_name ?? ''}</h2>
                                                    <div className="summary-location">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                            <path d="M10.0001 1.81818C6.49118 1.81818 3.63647 4.47669 3.63647 7.74444C3.63647 11.7998 9.33131 17.7533 9.57377 18.0048C9.80151 18.241 10.1991 18.2406 10.4265 18.0048C10.6689 17.7533 16.3637 11.7998 16.3637 7.74444C16.3637 4.47669 13.509 1.81818 10.0001 1.81818ZM10.0001 10.7261C8.23468 10.7261 6.79844 9.38854 6.79844 7.74444C6.79844 6.10034 8.23472 4.7628 10.0001 4.7628C11.7655 4.7628 13.2017 6.10037 13.2017 7.74447C13.2017 9.38857 11.7655 10.7261 10.0001 10.7261Z" fill="black" fill-opacity="0.35" />
                                                        </svg>
                                                        <span>{otherResult?.address ?? '—'}</span>
                                                    </div>
                                                </div>
                                                <div className="summary-price-group">
                                                    <div className="summary-price">{otherResult?.list_price != null && String(otherResult.list_price).trim() !== '' ? `€ ${formatPrice(otherResult.list_price)}` : '—'}</div>
                                                    <div className="summary-type">{propertyType}</div>
                                                </div>

                                            </div>

                                            <div className='summary-company-sec flex align-items-center justify-between gap-2'>
                                                <div className='flex align-items-center gap-2'>
                                                    <div className='summary-company-logo'>
                                                        <img src={otherResult?.agent_image ?? otherResult?.agent_image ?? ''} alt="Agent Logo" />
                                                    </div>
                                                    <div className='summary-company-name'>
                                                        <span>{otherResult?.agent_name ?? ([otherResult?.member_fname, otherResult?.member_lname].filter(Boolean).join(' ') || '—')}</span>

                                                    </div>
                                                </div>
                                                <div className='flex align-items-center gap-2'>
                                                    <div className='summary-company-logo'>
                                                        <img src={otherResult?.company_image ?? otherResult?.company_image ?? ''} alt="Company Logo" />
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="summary-features">
                                                <div className="feature">
                                                    <div className="feature-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                                            <g clip-path="url(#clip0_405_733)">
                                                                <path d="M9.68521 11.0902L2.66029 7.27238C2.34781 7.10264 1.97881 7.10965 1.67304 7.29142C1.36727 7.47314 1.18481 7.794 1.18481 8.14972V17.0062C1.18481 17.3645 1.37832 17.6972 1.68985 17.8743L8.7149 21.868C8.86977 21.956 9.03911 22 9.20851 22C9.38112 22 9.55369 21.9543 9.71062 21.863C10.0214 21.6822 10.207 21.3595 10.207 20.9999V11.9676C10.207 11.6013 10.0071 11.2651 9.68521 11.0902Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M19.5402 4.96845C19.5397 4.59451 19.3332 4.25534 19.0012 4.08328L11.3408 0.111819C11.0507 -0.0386167 10.705 -0.0374991 10.416 0.114613L2.86825 4.08608C2.53961 4.25908 2.33519 4.59721 2.33472 4.96862C2.33429 5.33994 2.53789 5.67855 2.86606 5.85228L10.4139 9.84854C10.56 9.92587 10.7205 9.96455 10.881 9.96455C11.0396 9.96455 11.1982 9.92681 11.3429 9.8513L19.0035 5.85512C19.335 5.68216 19.5407 5.34239 19.5402 4.96845Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M20.3267 7.2914C20.0211 7.10963 19.6519 7.10245 19.3395 7.27232L12.3144 11.0902C11.9926 11.2651 11.7927 11.6013 11.7927 11.9675V20.9998C11.7927 21.3594 11.9783 21.6821 12.2891 21.8629C12.446 21.9543 12.6185 21.9999 12.7912 21.9999C12.9605 21.9999 13.13 21.9559 13.2848 21.8679L20.3099 17.8742C20.6214 17.6971 20.8149 17.3645 20.8149 17.0061V8.1497C20.8149 7.79398 20.6324 7.47313 20.3267 7.2914Z" fill="black" fill-opacity="0.35" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_405_733">
                                                                    <rect width="22" height="22" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </div>
                                                    <div className="feature-info">
                                                        <div className="feature-label">{t('dimension')}</div>
                                                        <div className="feature-value">{otherResult?.LivingArea ?? otherResult?.living_area ?? '—'} {(otherResult?.LivingAreaUnits || otherResult?.living_area_unit || '').toString().toLowerCase().includes('meter') ? 'm' : 'f'}<sup className=''>2</sup></div>
                                                    </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                            <g clip-path="url(#clip0_405_741)">
                                                                <path d="M2.47178 13.9166V6.1042C2.47178 5.5634 2.03338 5.125 1.49263 5.125C0.951828 5.125 0.513428 5.5634 0.513428 6.1042V18.8958C0.513428 19.4366 0.951828 19.875 1.49263 19.875C2.03338 19.875 2.47178 19.4366 2.47178 18.8958V17.0614L22.5282 17.0142V18.8487C22.5282 19.3895 22.9666 19.8279 23.5074 19.8279C24.0481 19.8279 24.4865 19.3895 24.4865 18.8487V17.0142V14.4529V13.8695L2.47178 13.9166Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M24.4865 13.0779H9.60107V9.39035C9.60107 8.3203 10.4685 7.45285 11.5386 7.45285H20.575C22.7353 7.45285 24.4865 9.20405 24.4865 11.3643V13.0779Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M6.11706 12.656C7.4373 12.656 8.50756 11.5857 8.50756 10.2655C8.50756 8.94526 7.4373 7.875 6.11706 7.875C4.79683 7.875 3.72656 8.94526 3.72656 10.2655C3.72656 11.5857 4.79683 12.656 6.11706 12.656Z" fill="black" fill-opacity="0.35" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_405_741">
                                                                    <rect width="25" height="25" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </div>
                                                    <div className="feature-info">
                                                        <div className="feature-label">{t('bedrooms')}</div>
                                                        <div className="feature-value">{otherResult?.BedroomsTotal ?? '—'}</div>
                                                    </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                            <g clip-path="url(#clip0_405_749)">
                                                                <path d="M3.10162 23.8612C2.87721 24.1978 2.96818 24.6526 3.30475 24.8769C3.42965 24.9602 3.57076 25 3.71036 25C3.94703 25 4.17931 24.8855 4.32042 24.6737L4.87863 23.8364C4.42677 23.6381 3.99625 23.3999 3.59205 23.1255L3.10162 23.8612Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M21.4082 23.1255C21.004 23.3999 20.5735 23.6381 20.1216 23.8364L20.6798 24.6737C20.8209 24.8855 21.0531 25 21.2898 25C21.4294 25 21.5706 24.9602 21.6955 24.8769C22.0321 24.6526 22.123 24.1978 21.8986 23.8612L21.4082 23.1255Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M1.51367 14.1671V16.4551C1.51367 20.0898 4.47075 23.0469 8.10547 23.0469H16.8945C20.5292 23.0469 23.4863 20.0898 23.4863 16.4551V16.0286H11.3839C7.97895 16.0286 4.6646 15.4025 1.51367 14.1671Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M3.95483 8.63228V2.68555C3.95483 2.01245 4.50244 1.46484 5.17554 1.46484H6.1521C6.8252 1.46484 7.3728 2.01245 7.3728 2.68555V3.03306C6.24058 3.35928 5.41968 4.42187 5.41968 5.65601V5.85938C5.41968 6.26387 5.74761 6.5918 6.1521 6.5918H10.0583C10.4628 6.5918 10.7908 6.26387 10.7908 5.85938V5.61523C10.7908 4.38833 9.96348 3.35156 8.83765 3.03188V2.68555C8.83765 1.20474 7.63291 0 6.1521 0H5.17554C3.69473 0 2.48999 1.20474 2.48999 2.68555V8.04414C2.60532 8.07959 2.71919 8.12124 2.83096 8.1708C3.20249 8.33594 3.57725 8.4895 3.95483 8.63228Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M23.3947 11.451H11.384C8.21198 11.451 5.13517 10.7979 2.23776 9.5101C1.45095 9.16156 0.53244 9.51469 0.183368 10.2999C-0.165705 11.0852 0.187909 12.0053 0.973211 12.3543C4.2714 13.8205 7.77375 14.5638 11.3841 14.5638H23.3948C24.2546 14.5638 24.9512 13.8671 24.9512 13.0074C24.9511 12.1476 24.2545 11.451 23.3947 11.451Z" fill="black" fill-opacity="0.35" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_405_749">
                                                                    <rect width="25" height="25" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </div>
                                                    <div className="feature-info">
                                                        <div className="feature-label">{t('bathrooms')}</div>
                                                        <div className="feature-value">{otherResult?.BathroomsTotalInteger ?? '—'}</div>
                                                    </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                            <path d="M3.12492 20.5448V21.875C3.12492 22.1512 3.23467 22.4162 3.43001 22.6116C3.62537 22.8069 3.89031 22.9167 4.16659 22.9167H5.20825C5.48452 22.9167 5.74947 22.8069 5.94483 22.6116C6.14017 22.4162 6.24992 22.1512 6.24992 21.875V20.8333H18.7499V21.875C18.7499 22.1512 18.8597 22.4162 19.055 22.6116C19.2503 22.8069 19.5153 22.9167 19.7916 22.9167H20.8333C21.1095 22.9167 21.3745 22.8069 21.5698 22.6116C21.7651 22.4162 21.8749 22.1512 21.8749 21.875V20.5448C22.191 20.3635 22.4537 20.1022 22.6365 19.7871C22.8194 19.4721 22.916 19.1143 22.9166 18.75V15.625C22.9166 14.7594 22.3885 14.0187 21.6374 13.7031L20.2124 9.42812C20.0058 8.8057 19.608 8.26426 19.0761 7.88073C18.5441 7.4972 17.9047 7.29107 17.2489 7.29166H7.75096C7.09512 7.29107 6.45576 7.4972 5.92375 7.88073C5.39174 8.26426 4.99414 8.8057 4.78742 9.42812L3.36242 13.7031C2.98356 13.8618 2.66003 14.1288 2.43245 14.4708C2.20488 14.8127 2.08339 15.2143 2.08325 15.625V18.75C2.08325 19.5187 2.50409 20.1833 3.12492 20.5448ZM5.72909 18.75C5.52383 18.7499 5.3206 18.7095 5.13098 18.6308C4.94138 18.5522 4.76911 18.437 4.62401 18.2919C4.33099 17.9986 4.16645 17.601 4.16659 17.1865C4.16672 16.7719 4.33153 16.3744 4.62475 16.0813C4.91797 15.7883 5.31559 15.6238 5.73013 15.6239C6.14467 15.6241 6.54217 15.7888 6.8352 16.0821C7.12822 16.3753 7.29276 16.7729 7.29263 17.1875C7.29249 17.6021 7.12768 17.9996 6.83446 18.2926C6.54124 18.5856 6.14363 18.7501 5.72909 18.75ZM19.2708 18.75C18.8562 18.7499 18.4587 18.5851 18.1656 18.2919C17.8726 17.9986 17.7081 17.601 17.7083 17.1865C17.7084 16.7719 17.8731 16.3744 18.1664 16.0813C18.4596 15.7883 18.8572 15.6238 19.2718 15.6239C19.6864 15.6241 20.0839 15.7888 20.3769 16.0821C20.6699 16.3753 20.8344 16.7729 20.8343 17.1875C20.8342 17.6021 20.6694 17.9996 20.3762 18.2926C20.0829 18.5856 19.6853 18.7501 19.2708 18.75ZM7.75096 9.37499H17.2478C17.4666 9.37494 17.6797 9.44373 17.8572 9.57162C18.0346 9.6995 18.1673 9.87999 18.2364 10.0875L19.3885 13.5417H5.61138L6.76242 10.0875C6.90513 9.66145 7.30304 9.37499 7.75096 9.37499Z" fill="black" fill-opacity="0.35" />
                                                            <path d="M22.9166 7.69585V5.49898L12.8291 2.13648C12.6062 2.06186 12.3645 2.06516 12.1437 2.14586L2.08325 5.80419V8.02085L12.5155 4.22711L22.9166 7.69585Z" fill="black" fill-opacity="0.35" />
                                                        </svg>
                                                    </div>
                                                    <div className="feature-info">
                                                        <div className="feature-label">{t('garage')}</div>
                                                        <div className="feature-value">{otherResult?.GarageSpaces ?? '—'}</div>
                                                    </div>
                                                </div>
                                                <div className="feature no-border">
                                                    <div className="feature-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                            <g clip-path="url(#clip0_328_541)">
                                                                <path d="M17.7288 10.8302C17.6483 10.8302 17.5658 10.8417 17.4832 10.8644L16.5501 11.1214L15.5813 8.76108C15.3067 8.09242 14.4953 7.54834 13.7725 7.54834H4.70446C3.98159 7.54834 3.17028 8.09242 2.89581 8.76108L1.92819 11.1181L1.00661 10.8643C0.924142 10.8416 0.84158 10.8301 0.761128 10.8301C0.320065 10.8301 0 11.167 0 11.6311V12.1812C0 12.7229 0.44088 13.1638 0.982669 13.1638H1.08826L0.931848 13.5448C0.676824 14.1659 0.469226 15.2177 0.469226 15.8894V20.5784C0.469226 21.1202 0.910107 21.5611 1.4519 21.5611H2.73527C3.27706 21.5611 3.71794 21.1202 3.71794 20.5784V19.4075H14.7589V20.5784C14.7589 21.1202 15.1998 21.5611 15.7416 21.5611H17.0248C17.5666 21.5611 18.0075 21.1202 18.0075 20.5784V15.8895C18.0075 15.2179 17.7999 14.166 17.5448 13.5449L17.3884 13.1639H17.5071C18.0489 13.1639 18.4898 12.723 18.4898 12.1813V11.6312C18.4899 11.1671 18.1697 10.8302 17.7288 10.8302ZM2.63262 12.6302L4.09837 9.06005C4.26258 8.66008 4.75061 8.33277 5.18296 8.33277H13.294C13.7264 8.33277 14.2144 8.65999 14.3786 9.06005L15.8443 12.6302C16.0085 13.0302 15.7891 13.3575 15.3568 13.3575H3.12029C2.68785 13.3574 2.46851 13.0302 2.63262 12.6302ZM5.90455 17.1461C5.90455 17.3623 5.72759 17.5391 5.51155 17.5391H2.7272C2.51098 17.5391 2.33411 17.3622 2.33411 17.1461V15.8098C2.33411 15.5937 2.51098 15.4168 2.7272 15.4168H5.51155C5.72759 15.4168 5.90455 15.5937 5.90455 15.8098V17.1461ZM16.1164 17.1461C16.1164 17.3623 15.9395 17.5391 15.7234 17.5391H12.9391C12.7231 17.5391 12.5461 17.3622 12.5461 17.1461V15.8098C12.5461 15.5937 12.7231 15.4168 12.9391 15.4168H15.7234C15.9395 15.4168 16.1164 15.5937 16.1164 15.8098V17.1461Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M24.373 3.43872H19.7188C19.0411 3.43872 18.4897 3.99014 18.4897 4.66779V9.32208C18.4897 9.99982 19.0412 10.5512 19.7188 10.5512H21.5872V20.9973C21.5872 21.2507 21.7925 21.456 22.0459 21.456C22.2992 21.456 22.5045 21.2507 22.5045 20.9973V10.5513H24.373C25.0508 10.5513 25.6021 9.99991 25.6021 9.32217V4.66788C25.6021 3.99014 25.0508 3.43872 24.373 3.43872ZM23.3189 7.29775C23.0512 7.53874 22.6569 7.66093 22.1471 7.66093H21.4731C21.3922 7.66093 21.3263 7.72689 21.3263 7.8078V8.94431C21.3263 9.06779 21.2258 9.16814 21.1024 9.16814H20.592C20.4684 9.16814 20.368 9.06769 20.368 8.94431V5.04602C20.368 4.92245 20.4685 4.822 20.592 4.822H21.8777C22.7295 4.822 23.0474 4.95034 23.3087 5.17206C23.5843 5.40589 23.7239 5.76403 23.7239 6.23674C23.7238 6.69863 23.5877 7.05548 23.3189 7.29775Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M22.5892 5.76322C22.4648 5.66928 22.2447 5.62158 21.9352 5.62158H21.4729C21.392 5.62158 21.3262 5.68745 21.3262 5.76827V6.70232C21.3262 6.78314 21.392 6.849 21.4729 6.849H21.7499C21.8516 6.849 22.016 6.84148 22.1163 6.83221C22.2136 6.82332 22.4884 6.7835 22.5892 6.70736C22.7102 6.61581 22.7716 6.45747 22.7716 6.23685C22.7716 6.01412 22.7102 5.85477 22.5892 5.76322Z" fill="black" fill-opacity="0.35" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_328_541">
                                                                    <rect width="25" height="25" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </div>
                                                    <div className="feature-info">
                                                        <div className="feature-label">{t('parking')}</div>
                                                        <div className="feature-value">{otherResult?.ParkingTotal ?? '—'}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>

                                <aside className="contact-right">
                                    <div className="contact-card">
                                        <div className='content-holder'>
                                            <div className='content-holder-sec'>
                                                <h3 className="contact-title">{[otherResult?.PostalCode, otherResult?.city_name, "|", otherResult?.StateOrProvince].filter(Boolean).join(' ')}</h3>
                                                <div className="contact-location">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                        <path d="M10.0001 1.81818C6.49118 1.81818 3.63647 4.47669 3.63647 7.74444C3.63647 11.7998 9.33131 17.7533 9.57377 18.0048C9.80151 18.241 10.1991 18.2406 10.4265 18.0048C10.6689 17.7533 16.3637 11.7998 16.3637 7.74444C16.3637 4.47669 13.509 1.81818 10.0001 1.81818ZM10.0001 10.7261C8.23468 10.7261 6.79844 9.38854 6.79844 7.74444C6.79844 6.10034 8.23472 4.7628 10.0001 4.7628C11.7655 4.7628 13.2017 6.10037 13.2017 7.74447C13.2017 9.38857 11.7655 10.7261 10.0001 10.7261Z" fill="black" fill-opacity="0.35" />
                                                    </svg>
                                                    <span>{otherResult?.address ?? '—'}</span>
                                                </div>
                                                <div className="contact-fields">
                                                    {(Array.isArray(infoCardResult) ? infoCardResult : []).filter(Boolean).map((cardList, idx) => {
                                                        const displayValue = cardList.field_value !== undefined && cardList.field_value !== null && String(cardList.field_value).trim() !== ''
                                                            ? cardList.field_value
                                                            : (Array.isArray(cardList.data) && cardList.data[0] !== undefined && cardList.data[0] !== null && String(cardList.data[0]).trim() !== '' ? cardList.data[0] : null);
                                                        const isEmpty = displayValue === null || displayValue === undefined || (typeof displayValue === 'string' && displayValue.trim() === '');
                                                        const label = (cardList.field_name_label || cardList.field_name || '').replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/f2\/m2/i, 'Area unit').trim();
                                                        const isPublicRemarks = cardList.field_name_label === 'PublicRemarks';
                                                        return (
                                                            <div className="field-holder" key={`${cardList.field_name_label ?? cardList.field_name ?? ''}_${idx}`}>
                                                                {isPublicRemarks ? (
                                                                    <div className="grid-item text-left pub-remark-block w-full">
                                                                        <p className="font-light text-base opacity-80 field-label">{label}</p>
                                                                        {isEmpty ? (
                                                                            <p className="text-base font-bold field-value">N/A</p>
                                                                        ) : (
                                                                            <div className="text-base field-value pub-remarks-content" dangerouslySetInnerHTML={{ __html: typeof displayValue === 'string' ? displayValue : String(displayValue) }} />
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    <div className="grid-item text-left flex w-full justify-between">
                                                                        <p className="font-light text-base opacity-80 field-label">{label}</p>
                                                                        {isEmpty ? (
                                                                            <p className="text-base font-bold field-value">N/A</p>
                                                                        ) : (
                                                                            <p className="text-base font-bold field-value">{typeof displayValue === 'string' ? displayValue.trim() : displayValue}</p>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                        {/* <button className="btn-primary contact-cta" onClick={() => askInfoApi()}>Ask Information</button> */}
                                    </div>



                                </aside>
                            </section>

                            {/* Desktop: gear icon with dropdown – from My Listings: 6 actions; else: original Send/Remove Feed Request + View gallery */}
                            {!isMobile && !fromNewAvailable && (
                                <div className="btn-section btn-section-gear details-page-gear" ref={gearMenuRef}>
                                    <button
                                        type="button"
                                        className={`btn-primary gear-btn ${gearSpinning ? 'gear-spin' : ''}`}
                                        onClick={() => {
                                            setGearMenuOpen((prev) => !prev);
                                            setGearSpinning(true);
                                            setTimeout(() => setGearSpinning(false), 500);
                                        }}
                                        aria-label="Options"
                                        aria-expanded={gearMenuOpen}
                                    >
                                        <i className="fa-solid fa-gear"></i>
                                    </button>
                                    {gearMenuOpen && (
                                        <ul className="gear-dropdown" aria-label="Options list">
                                            {showOwnerListingActions ? (
                                                <>
                                                    <li>
                                                        <button type="button" className="gear-dropdown-item" onClick={() => openDeleteConfirm()} aria-label="Delete">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                <polyline points="3 6 5 6 21 6" />
                                                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                                                <line x1="10" y1="11" x2="10" y2="17" />
                                                                <line x1="14" y1="11" x2="14" y2="17" />
                                                            </svg>
                                                            <span>{stringsoflanguages.delete}</span>
                                                        </button>
                                                    </li>

                                                    <li>
                                                        <button type="button" className="gear-dropdown-item" onClick={openView360Modal} aria-label="360 view">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                                                                <path d="M3 3v5h5" />
                                                                <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
                                                                <path d="M16 21h5v-5" />
                                                            </svg>
                                                            <span>{stringsoflanguages.view360}</span>
                                                        </button>
                                                    </li>

                                                    <li>
                                                        <button type="button" className="gear-dropdown-item" onClick={() => setGearMenuOpen(false)} aria-label="Share or group">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                                                <circle cx="9" cy="7" r="4" />
                                                                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                                            </svg>
                                                            <span>{stringsoflanguages.shareOrGroup}</span>
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button type="button" className="gear-dropdown-item" onClick={openFolderModal} aria-label="Folder">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
                                                                <line x1="12" y1="11" x2="12" y2="17" />
                                                                <line x1="9" y1="14" x2="15" y2="14" />
                                                            </svg>
                                                            <span>{stringsoflanguages.folder}</span>
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button type="button" className="gear-dropdown-item" onClick={() => { setGearMenuOpen(false); handleExpandClick(); }} aria-label="Gallery">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                                                                <circle cx="8.5" cy="8.5" r="1.5" />
                                                                <polyline points="21 15 16 10 5 21" />
                                                            </svg>
                                                            <span>{stringsoflanguages.gallery}</span>
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button type="button" className="gear-dropdown-item" onClick={goToEditListing} aria-label="Edit">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                                            </svg>
                                                            <span>{stringsoflanguages.edit}</span>
                                                        </button>
                                                    </li>
                                                </>
                                            ) : (
                                                <>
                                                    {String(view360Link || '').trim() !== '' && (
                                                        <li>
                                                            <button type="button" className="gear-dropdown-item" onClick={openView360Modal} aria-label="360 view">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                    <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                                                                    <path d="M3 3v5h5" />
                                                                    <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
                                                                    <path d="M16 21h5v-5" />
                                                                </svg>
                                                                <span>{stringsoflanguages.view360}</span>
                                                            </button>
                                                        </li>
                                                    )}
                                                    {String(resultAll?.is_shared) == '1' ? (
                                                        <li>
                                                            <button type="button" className="gear-dropdown-item" onClick={() => { setGearMenuOpen(false); askInfoApi(); }}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                                    <g>
                                                                        <g>
                                                                            <path d="M256,0C114.853,0,0,114.833,0,256s114.853,256,256,256c141.167,0,256-114.833,256-256S397.147,0,256,0z M256,472.341
			c-119.295,0-216.341-97.046-216.341-216.341S136.705,39.659,256,39.659S472.341,136.705,472.341,256S375.295,472.341,256,472.341z
			" fill="currentColor"></path>
                                                                        </g>
                                                                    </g>
                                                                    <g>
                                                                        <g>
                                                                            <path d="M355.148,234.386H156.852c-10.946,0-19.83,8.884-19.83,19.83s8.884,19.83,19.83,19.83h198.296
			c10.946,0,19.83-8.884,19.83-19.83S366.094,234.386,355.148,234.386z" fill="currentColor"></path>
                                                                        </g>
                                                                    </g>
                                                                </svg>
                                                                <span>{stringsoflanguages.removeFeedRequest}</span>
                                                            </button>
                                                        </li>
                                                    ) : (
                                                        <li>
                                                            <button type="button" className="gear-dropdown-item" onClick={() => { setGearMenuOpen(false); askInfoApi(); }}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                                    <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                </svg>
                                                                <span>{stringsoflanguages.sendFeedRequest}</span>
                                                            </button>
                                                        </li>
                                                    )}
                                                    <li>
                                                        <button type="button" className="gear-dropdown-item" onClick={() => { setGearMenuOpen(false); handleExpandClick(); }}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                                <path d="M21.5 10.9V4.1C21.5 2.6 20.86 2 19.27 2H15.23C13.64 2 13 2.6 13 4.1V10.9C13 12.4 13.64 13 15.23 13H19.27C20.86 13 21.5 12.4 21.5 10.9Z" fill="currentColor" />
                                                                <path d="M11 13.1V19.9C11 21.4 10.36 22 8.77 22H4.73C3.14 22 2.5 21.4 2.5 19.9V13.1C2.5 11.6 3.14 11 4.73 11H8.77C10.36 11 11 11.6 11 13.1Z" fill="currentColor" />
                                                                <path d="M21.5 19.9V17.1C21.5 15.6 20.86 15 19.27 15H15.23C13.64 15 13 15.6 13 17.1V19.9C13 21.4 13.64 22 15.23 22H19.27C20.86 22 21.5 21.4 21.5 19.9Z" fill="currentColor" />
                                                                <path d="M11 6.9V4.1C11 2.6 10.36 2 8.77 2H4.73C3.14 2 2.5 2.6 2.5 4.1V6.9C2.5 8.4 3.14 9 4.73 9H8.77C10.36 9 11 8.4 11 6.9Z" fill="currentColor" />
                                                            </svg>
                                                            <span>{stringsoflanguages.viewGallery}</span>
                                                        </button>
                                                    </li>
                                                </>
                                            )}
                                        </ul>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </div>
            </main>

            {/* Mobile footer nav — same actions/conditions as desktop gear menu */}
            {isMobile && showOwnerListingActions && !fromNewAvailable && (
                <nav className="mobile-bottom-nav liquidGlass-wrapper dock portfolio-details-footer-nav portfolio-details-footer-nav-from-listings" aria-label="Listing actions">
                    <div className="liquidGlass-effect" aria-hidden="true" />
                    <div className="liquidGlass-shine" aria-hidden="true" />
                    <div className="mobile-nav-item" aria-label="Delete" onClick={() => openDeleteConfirm()}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="3 6 5 6 21 6" />
                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                            <line x1="10" y1="11" x2="10" y2="17" />
                            <line x1="14" y1="11" x2="14" y2="17" />
                        </svg>
                    </div>
                    <div className="mobile-nav-item" aria-label="360 view" onClick={openView360Modal}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                            <path d="M3 3v5h5" />
                            <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
                            <path d="M16 21h5v-5" />
                        </svg>
                    </div>
                    <div className="mobile-nav-item" aria-label="Share or group">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                            <circle cx="9" cy="7" r="4" />
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                    </div>
                    <div
                        className="mobile-nav-item"
                        role="button"
                        tabIndex={0}
                        aria-label="Folder"
                        onClick={openFolderModal}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                openFolderModal();
                            }
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
                            <line x1="12" y1="11" x2="12" y2="17" />
                            <line x1="9" y1="14" x2="15" y2="14" />
                        </svg>
                    </div>
                    <div className="mobile-nav-item" onClick={handleExpandClick} aria-label="Gallery">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                            <circle cx="8.5" cy="8.5" r="1.5" />
                            <polyline points="21 15 16 10 5 21" />
                        </svg>
                    </div>
                    <div
                        className="mobile-nav-item"
                        role="button"
                        tabIndex={0}
                        aria-label="Edit"
                        onClick={goToEditListing}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                goToEditListing();
                            }
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                        </svg>
                    </div>
                </nav>
            )}
            {isMobile && !showOwnerListingActions && !fromNewAvailable && (
                <nav className="mobile-bottom-nav liquidGlass-wrapper dock portfolio-details-footer-nav" aria-label="Portfolio actions">
                    <div className="liquidGlass-effect" aria-hidden="true" />
                    <div className="liquidGlass-shine" aria-hidden="true" />
                    {String(view360Link || '').trim() !== '' && (
                        <div className="mobile-nav-item" aria-label="360 view" onClick={openView360Modal}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                                <path d="M3 3v5h5" />
                                <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
                                <path d="M16 21h5v-5" />
                            </svg>
                        </div>
                    )}
                    {String(resultAll?.is_shared) === '1' ? (
                        <div className="mobile-nav-item" aria-label="Remove feed request" onClick={() => askInfoApi()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512" fill="currentColor">
                                <path d="M256,0C114.853,0,0,114.833,0,256s114.853,256,256,256c141.167,0,256-114.833,256-256S397.147,0,256,0z M256,472.341
			c-119.295,0-216.341-97.046-216.341-216.341S136.705,39.659,256,39.659S472.341,136.705,472.341,256S375.295,472.341,256,472.341z
			" />
                                <path d="M355.148,234.386H156.852c-10.946,0-19.83,8.884-19.83,19.83s8.884,19.83,19.83,19.83h198.296
			c10.946,0,19.83-8.884,19.83-19.83S366.094,234.386,355.148,234.386z" />
                            </svg>
                        </div>
                    ) : (
                        <div className="mobile-nav-item" aria-label="Send feed request" onClick={() => askInfoApi()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    )}
                    <div className="mobile-nav-item" onClick={handleExpandClick} aria-label="View gallery">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M21.5 10.9V4.1C21.5 2.6 20.86 2 19.27 2H15.23C13.64 2 13 2.6 13 4.1V10.9C13 12.4 13.64 13 15.23 13H19.27C20.86 13 21.5 12.4 21.5 10.9Z" fill="currentColor" />
                            <path d="M11 13.1V19.9C11 21.4 10.36 22 8.77 22H4.73C3.14 22 2.5 21.4 2.5 19.9V13.1C2.5 11.6 3.14 11 4.73 11H8.77C10.36 11 11 11.6 11 13.1Z" fill="currentColor" />
                            <path d="M21.5 19.9V17.1C21.5 15.6 20.86 15 19.27 15H15.23C13.64 15 13 15.6 13 17.1V19.9C13 21.4 13.64 22 15.23 22H19.27C20.86 22 21.5 21.4 21.5 19.9Z" fill="currentColor" />
                            <path d="M11 6.9V4.1C11 2.6 10.36 2 8.77 2H4.73C3.14 2 2.5 2.6 2.5 4.1V6.9C2.5 8.4 3.14 9 4.73 9H8.77C10.36 9 11 8.4 11 6.9Z" fill="currentColor" />
                        </svg>
                    </div>

                </nav>
            )
            }
            {folderModalOpen && (
                <div
                    className="modal-overlay"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="folder-modal-title"
                    onClick={closeFolderModal}
                >
                    <div
                        className="logout-modal portfolio-folder-modal"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2 id="folder-modal-title" className="text-white mb-4 text-center">
                            {stringsoflanguages.folder}
                        </h2>
                        <div className="portfolio-folder-modal-options">
                            <button type="button" className="folder-modal-option-btn" onClick={handleFolderPublic}>
                                {stringsoflanguages.public}
                            </button>
                            <button type="button" className="folder-modal-option-btn" onClick={handleFolderPrivate}>
                                {stringsoflanguages.private}
                            </button>
                            <button type="button" className="folder-modal-option-btn" onClick={handleFolderEdit}>
                                {stringsoflanguages.edit}
                            </button>
                        </div>
                        <button type="button" className="folder-modal-cancel-btn" onClick={closeFolderModal}>
                            {stringsoflanguages.cancel}
                        </button>
                    </div>
                </div>
            )}
            {view360ModalOpen && (
                <div
                    className="modal-overlay"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="view-360-modal-title"
                    onClick={closeView360Modal}
                >
                    <div
                        className="logout-modal"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2 id="view-360-modal-title" className="text-white mb-2">
                            {stringsoflanguages.view360}
                        </h2>
                        {isEditing360Link ? (
                            <>
                                <input
                                    type="text"
                                    value={view360Input}
                                    onChange={(e) => setView360Input(e.target.value)}
                                    placeholder="Enter 360 link"
                                    className="w-full mb-4"
                                    style={{ padding: '10px 12px', borderRadius: 6, border: '1px solid #d9d9d9' }}
                                />
                                <div className="btn-sec flex-col gap-2">
                                    <button type="button" className="save-btn" onClick={handleSave360Link}>{stringsoflanguages.save}</button>
                                    <button type="button" className="cancel-btn" onClick={closeView360Modal}>{stringsoflanguages.cancel}</button>
                                </div>
                            </>
                        ) : (
                            <>
                                <p className="text-white mb-4">
                                    {isFetching360Link ? stringsoflanguages.checkingLink : (view360Link ? view360Link : stringsoflanguages.noLinkAvailable)}
                                </p>
                                <div className="btn-sec flex-col gap-2">
                                    <button type="button" className="save-btn" onClick={handleOpen360Link} disabled={isFetching360Link}>{stringsoflanguages.openLink}</button>
                                    <button
                                        type="button"
                                        className="save-btn"
                                        onClick={() => {
                                            setIsAdd360Mode(!view360Link);
                                            setIsEditing360Link(true);
                                        }}
                                    >
                                        {view360Link ? stringsoflanguages.edit : stringsoflanguages.add}
                                    </button>
                                    <button type="button" className="cancel-btn" onClick={closeView360Modal}>{stringsoflanguages.cancel}</button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
            {deleteConfirmOpen && (
                <div
                    className="modal-overlay"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="delete-listing-confirm-title"
                    onClick={closeDeleteConfirm}
                >
                    <div
                        className="logout-modal"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2 id="delete-listing-confirm-title" className="text-white mb-2">
                            Delete listing?
                        </h2>
                        <p className="text-white mb-4">Are you sure you want to remove this listing? This cannot be undone.</p>
                        <div className="btn-sec">
                            <button type="button" className="save-btn" onClick={confirmDeleteListing}>
                                Yes
                            </button>
                            <button type="button" className="cancel-btn" onClick={closeDeleteConfirm}>
                                No
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <svg style={{ display: 'none' }} aria-hidden="true">
                <filter id="glass-distortion-details" x="0%" y="0%" width="100%" height="100%" filterUnits="objectBoundingBox">
                    <feTurbulence type="fractalNoise" baseFrequency="0.01 0.01" numOctaves="1" seed="5" result="turbulence" />
                    <feComponentTransfer in="turbulence" result="mapped">
                        <feFuncR type="gamma" amplitude="1" exponent="10" offset="0.5" />
                        <feFuncG type="gamma" amplitude="0" exponent="1" offset="0" />
                        <feFuncB type="gamma" amplitude="0" exponent="1" offset="0.5" />
                    </feComponentTransfer>
                    <feGaussianBlur in="turbulence" stdDeviation="3" result="softMap" />
                    <feSpecularLighting in="softMap" surfaceScale="5" specularConstant="1" specularExponent="100" lightingColor="white" result="specLight">
                        <fePointLight x="-200" y="-200" z="300" />
                    </feSpecularLighting>
                    <feComposite in="specLight" operator="arithmetic" k1="0" k2="1" k3="1" k4="0" result="litImage" />
                    <feDisplacementMap in="SourceGraphic" in2="softMap" scale="150" xChannelSelector="R" yChannelSelector="G" />
                </filter>
            </svg>
        </>
    );
}